import { useEffect, useState } from "react";
import InstantSearchContent from "./InstantSearchContent";
import { Sheet, SheetContent, SheetPortal } from "../search-results/components/ui/Sheet";

export default function InstantSearchDrawer({
  triggerClassName,
  isPortal = false,
  portalContainer,
}: {
  triggerClassName: string; // Single class name shared by all search triggers
  isPortal?: boolean;
  portalContainer?: HTMLDivElement | null;
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClick = () => setIsOpen(true);
    const triggerElements: HTMLElement[] = [];

    // Get ALL elements with the trigger class
    const elements = document.querySelectorAll(`.${triggerClassName}`);
    elements.forEach(element => {
      const triggerEl = element as HTMLElement;
      triggerEl.addEventListener("click", handleClick);
      triggerElements.push(triggerEl);
    });

    return () => {
      triggerElements.forEach(triggerEl => {
        triggerEl.removeEventListener("click", handleClick);
      });
    };
  }, [triggerClassName]);

  const content = (
    <div className="!tw-h-full tw-transition-[width] tw-duration-200 tw-bg-white">
      {/* Move the background colour to where it needs to be */}
      <div className="tw-min-w-[calc(50vw_-_558px)] tw-flex">
        {/* Spacer to push content over (and keep it there) */}
        <div className="tw-min-w-[calc(50vw_-_960px)]"></div>

        {/* content */}
        <div className="tw-w-full tw-max-w-[1560px] max-[989px]:tw-w-screen max-[989px]:tw-px-5 max-[2000px]:tw-pl-10 tw-pr-5">
          <InstantSearchContent />
        </div>
      </div>
    </div>
  );

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      {isPortal ? (
        <SheetPortal container={portalContainer}>
          <SheetContent side="left">{content}</SheetContent>
        </SheetPortal>
      ) : (
        <SheetContent side="left">{content}</SheetContent>
      )}
    </Sheet>
  );
}
